import { css } from '@emotion/react';
import { Button, Typography } from '@uniquegood/realworld-studio-design';
import { useHistory } from 'react-router-dom';
import { useParamsWithMatchPath } from '@/hooks';

export default function ReleaseManageButton() {
  const { appId, projectId } = useParamsWithMatchPath();
  const history = useHistory();
  const handleClick = () => {
    history.push(`/apps/${appId}/projects/${projectId}/release`);
  };

  return (
    <Button icon="rocket_solid" cssStyle={ReleaseButtonStyle} onClick={handleClick}>
      <Typography type="button" textColor="white">
        출시 관리
      </Typography>
    </Button>
  );
}

const ReleaseButtonStyle = css`
  height: 36px;
  padding: 8px 16px;
  border-radius: 12px;
  background-color: black;

  &:hover {
    background-color: #191919;
  }

  .ButtonContent .Icon {
    color: #ffffff;
  }

  svg {
    color: #ffffff;
  }
`;
